/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const VideoCallProviderEnum = {
    Webprax: 'WEBPRAX',
    WebpraxV2: 'WEBPRAX_V2',
    SprechstundeOnline: 'SPRECHSTUNDE_ONLINE'
} as const;
export type VideoCallProviderEnum = typeof VideoCallProviderEnum[keyof typeof VideoCallProviderEnum];

